import React from "react";
import "./App.css";
import { Amplify } from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import awsExports from "./aws-exports.js";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { FilterProvider } from "./FilterContext";
import ProtectedRoute from "./components/ProtectedRoute"; // Import the ProtectedRoute component

// Import all your pages
import Login from "./pages/Login";
import D01_Demographics from "./pages/D01_Demographics";
import Signinillustration from "./pages/Signinillustration";
import LandingPagePage from "./pages/LandingPage.jsx";
import Discover from "./pages/Discover.jsx";
import Compose from "./pages/Compose.jsx";
import Analyze from "./pages/Analyze.jsx";
import Analyze2 from "./pages/Analyze2.jsx";
import Analyze3 from "./pages/Analyze3.jsx";
import Analyze4 from "./pages/Analyze4.jsx";
import D02_Overall_Engagement from "./pages/D02_Overall_Engagement.jsx";
import D03_Engagement_Summary from "./pages/D03_Engagement_Summary.jsx";
import D04_Responses_by_Demographic_Category from "./pages/D04_Responses_by_Demographic_Category.jsx";
import D05_Response_Distribution from "./pages/D05_Response_Distribution.jsx";
import D06_Detailed_Scores_by_Demographic_Category from "./pages/D06_Detailed_Scores_by_Demographic_Category.jsx";
import D07_Range_of_Responses from "./pages/D07_Range_of_Responses.jsx";
import D08_Self_Reported_Engagement from "./pages/D08_Self_Reported_Engagement.jsx";
import D09_Engagement_Questions_Sorted from "./pages/D09_Engagement_Questions_Sorted.jsx";
import D10_Open_Text_Responses from "./pages/D10_Open_Text_Responses.jsx";
import D11_Open_Text_Heatmap from "./pages/D11_Open_Text_Heatmap.jsx";
import D12_Engagement_Areas_by_Impact from "./pages/D12_Engagement_Areas_by_Impact.jsx";
import D13_Survey_Specific_Questions from "./pages/D13_Survey_Specific_Questions.jsx";
// import D14_Year_over_Year_by_Area from "./pages/D14_Year_over_Year_by_Area.jsx";
// import D15_Year_over_Year_by_Question from "./pages/D15_Year_over_Year_by_Question.jsx";
// import D16_Year_over_Year_Self_Reported from "./pages/D16_Year_over_Year_Self_Reported.jsx";
import D17_Open_Text_Top_Themes from "./pages/D17_Open_Text_Top_Themes.jsx";
import GenerateReport from "./pages/GenerateReport.jsx";

Amplify.configure(awsExports);

function App() {
  return (
    <Authenticator.Provider>
      <FilterProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Login />} />
            <Route path="/signinillustration" element={<Signinillustration />} />

            {/* Protected Routes */}
            <Route
              path="/D01_Demographics"
              element={
                <ProtectedRoute>
                  <D01_Demographics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/landingpage"
              element={
                <ProtectedRoute>
                  <LandingPagePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/discover"
              element={
                <ProtectedRoute>
                  <Discover />
                </ProtectedRoute>
              }
            />
            <Route
              path="/compose"
              element={
                <ProtectedRoute>
                  <Compose />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analyze"
              element={
                <ProtectedRoute>
                  <Analyze />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analyze2"
              element={
                <ProtectedRoute>
                  <Analyze2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analyze3"
              element={
                <ProtectedRoute>
                  <Analyze3 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analyze4"
              element={
                <ProtectedRoute>
                  <Analyze4 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D02_Overall_Engagement"
              element={
                <ProtectedRoute>
                  <D02_Overall_Engagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D03_Engagement_Summary"
              element={
                <ProtectedRoute>
                  <D03_Engagement_Summary />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D04_Responses_by_Demographic_Category"
              element={
                <ProtectedRoute>
                  <D04_Responses_by_Demographic_Category />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D05_Response_Distribution"
              element={
                <ProtectedRoute>
                  <D05_Response_Distribution />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D06_Detailed_Scores_by_Demographic_Category"
              element={
                <ProtectedRoute>
                  <D06_Detailed_Scores_by_Demographic_Category />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D07_Range_of_Responses"
              element={
                <ProtectedRoute>
                  <D07_Range_of_Responses />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D08_Self_Reported_Engagement"
              element={
                <ProtectedRoute>
                  <D08_Self_Reported_Engagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D09_Engagement_Questions_Sorted"
              element={
                <ProtectedRoute>
                  <D09_Engagement_Questions_Sorted />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D10_Open_Text_Responses"
              element={
                <ProtectedRoute>
                  <D10_Open_Text_Responses />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D11_Open_Text_Heatmap"
              element={
                <ProtectedRoute>
                  <D11_Open_Text_Heatmap />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D12_Engagement_Areas_by_Impact"
              element={
                <ProtectedRoute>
                  <D12_Engagement_Areas_by_Impact />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D13_Survey_Specific_Questions"
              element={
                <ProtectedRoute>
                  <D13_Survey_Specific_Questions />
                </ProtectedRoute>
              }
            />
            {/* <Route
              path="/D14_Year_over_Year_by_Area"
              element={
                <ProtectedRoute>
                  <D14_Year_over_Year_by_Area />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D15_Year_over_Year_by_Question"
              element={
                <ProtectedRoute>
                  <D15_Year_over_Year_by_Question />
                </ProtectedRoute>
              }
            />
            <Route
              path="/D16_Year_over_Year_Self_Reported"
              element={
                <ProtectedRoute>
                  <D16_Year_over_Year_Self_Reported />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/D17_Open_Text_Top_Themes"
              element={
                <ProtectedRoute>
                  <D17_Open_Text_Top_Themes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/generatereport"
              element={
                <ProtectedRoute>
                  <GenerateReport />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </FilterProvider>
    </Authenticator.Provider>
  );
}

export default App;
